import React from "react"
import { Link } from "gatsby"
import Helmet from "react-helmet"
import ToggleButton from "./toggle-button"
import favicon from "../../content/assets/favicon/favicon.ico"
import logo from "../../content/assets/logo.svg"
import "../styles/layout.css"

const Layout = ({ children, heading }) => {
  return (
    <React.Fragment>
      <Helmet>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="..//apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="../../content/assets/favicon/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
      <div class="wrapper">
        <aside class="sidebar">
          <Link to="" class="logo-link">
            <img src={logo} alt="logo" height="150" width="150" />
          </Link>
          <nav class="main-nav">
            <ul class="main-menu">
              <li class="menu-item">
                <Link to="/category/knowledge" activeClassName="active">
                  Kiến thức
                </Link>
              </li>
              <li class="menu-item">
                <Link to="/category/tutorial" activeClassName="active">
                  UI Tutorial
                </Link>
              </li>
            </ul>
          </nav>
        </aside>
        <div className="main">
          <div className="top">
            <h3>{heading}</h3>
            <ToggleButton />
          </div>
          {children}
        </div>
      </div>
    </React.Fragment>
  )
}

export default Layout
